import { Link } from "react-router-dom";

import { Resource } from "@app/resources";
import { ColumnConfig, SortDirections, Waffles } from "@app/shared/waffles";
import { QESButton } from "@app/shared/qes-standards";
import { JSX } from "react";


interface MembershipRiskProjectTableProps {
  countyName: string;
  filterPath: string;
  onBreadCrumbClick: () => void;
  projectIds: number[];
  projectResources: Resource[];
}

const columnConfig: ColumnConfig = {
  projectNameLink: {
    displayText: "Projects",
    testId: "projects",
  },
};

interface MembershipRiskProjectsWaffleToppings {
  filterPath: string;
  key: string;
  projectName: string;
  projectNameLink: JSX.Element;
}

const MembershipRiskProjectTable = (props: MembershipRiskProjectTableProps): JSX.Element => {
  const data = props.projectResources.filter((fr) => props.projectIds.includes(fr.resourceId)).map((pr) => {
    let tileUrl = `/projects/${pr.resourceId}/adequacy`;
    if (props.filterPath) {
      tileUrl += props.filterPath;
    }

    return ({
      filterPath: props.filterPath,
      key: pr.resourceId.toString(),
      projectName: pr.name,
      projectNameLink: (
        <Link to={tileUrl}>
          {pr.name}
        </Link>
      ),
    });
  });

  const customSort = (segment: MembershipRiskProjectsWaffleToppings[], column: keyof MembershipRiskProjectsWaffleToppings, sortDirection: SortDirections) => {
    if (sortDirection === SortDirections.None) {
      return data;
    }
    const multiplier = sortDirection === SortDirections.Asc ? 1 : -1;
    switch (column) {
      case "projectNameLink":
        return segment.sort((a, b) => (a.projectName.toLowerCase() > b.projectName.toLowerCase() ? 1 : -1) * multiplier);
      default:
        console.warn(`There's no function to handle sorting column ${column}.`);
    }
  };

  return (
    <>
      <QESButton
        qesType="secondary"
        className="text-info p-0 mb-3"
        onClick={props.onBreadCrumbClick}
        qesTestId="membership-risk-project-table__go-back"
      >
        Return to Counties
      </QESButton>
      <Waffles<MembershipRiskProjectsWaffleToppings>
        columns={columnConfig}
        customSort={customSort}
        data={data}
        testId="membership-risk-table"
      />
    </>
  );
};

export default MembershipRiskProjectTable;
